import { AbstractCoroutine2jzyhqo91sb0o as AbstractCoroutine } from '../AbstractCoroutine.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { recoverResult92pymwoef8np as recoverResult } from '../CompletionState.mjs';
import { resumeCancellableWithInternalk8vmvm2je8v0 as resumeCancellableWithInternal } from './DispatchedContinuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../CoroutineScope.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ScopeCoroutineClass;
function ScopeCoroutine() {
  if (ScopeCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(context, uCont) {
        super(context, true, true);
        this.fz_1 = uCont;
      }
      yx() {
        return true;
      }
      ow(state) {
        resumeCancellableWithInternal(intercepted(this.fz_1), recoverResult(state, this.fz_1));
      }
      gz() {
      }
      nw(state) {
        this.fz_1.oc(recoverResult(state, this.fz_1));
      }
    }
    initMetadataForClass($, 'ScopeCoroutine', VOID, VOID, VOID, [0]);
    ScopeCoroutineClass = $;
  }
  return ScopeCoroutineClass;
}
var ContextScopeClass;
function ContextScope() {
  if (ContextScopeClass === VOID) {
    class $ {
      constructor(context) {
        this.h1k_1 = context;
      }
      dw() {
        return this.h1k_1;
      }
      toString() {
        return 'CoroutineScope(coroutineContext=' + toString(this.h1k_1) + ')';
      }
    }
    initMetadataForClass($, 'ContextScope', VOID, VOID, [CoroutineScope()]);
    ContextScopeClass = $;
  }
  return ContextScopeClass;
}
//region block: exports
export {
  ContextScope as ContextScoper0znlsj7ufhq,
  ScopeCoroutine as ScopeCoroutine2c07fgm3ekmnx,
};
//endregion

//# sourceMappingURL=Scopes.mjs.map
